import useStore from "../../../../store"
import { motion } from "framer-motion"
import BackButton from "../../../common/BackButton"
import { useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import TransferHistoryBody from "../../../Dealer/TransferHistory/TransferHistoryBody"
import TxnPageBody from "../../../Dealer/TransferPage/TxnPageBody"
import TransferPageBody from "../../../Dealer/TransferPage/TransferPageBody"
import { useIsMobile } from "../../../../hooks/useIsMobile"

export default function DealerTransactions() {
  const dealer = useStore((state) => state.dealer)
  const fetchPendingTransfers = useStore((state) => state.fetchPendingTransfers)
  const fetchProcessingTransfers = useStore((state) => state.fetchProcessingTransfers)
  const setBreadcrumbTrail = useStore((state) => state.setBreadcrumbTrail)
  const breadcrumbTrail = useStore((state) => state.breadcrumbTrail)

  const [selectedTransaction, setSelectedTransaction] = useState(null)
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  useEffect(() => {
    fetchPendingTransfers()
    fetchProcessingTransfers()
    setSelectedTransaction(null)
  }, [dealer])

  const handleClick = (object) => {
    if (isMobile) {
      const newBreadcrumbTrail = [
        ...breadcrumbTrail,
        {
          label: `Transaction #${object?.id}`,
        }
      ]
      setBreadcrumbTrail(newBreadcrumbTrail)
      navigate(`/${object.type}/${object.id}`)
    } else {
      setSelectedTransaction(object)
    }
  }

  return(
    <div className="w-full">
      {selectedTransaction ?
        <div className="overflow-x-hidden pt-2">
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            transition={{ type: 'tween', duration: 0.2 }}
          >
            <BackButton onClick={() => setSelectedTransaction(null)} />
            {selectedTransaction.type === 'transfers' ?
              <TransferPageBody transferId={selectedTransaction.id} shiftPill={true} />
            :
              <TxnPageBody txnId={selectedTransaction.id} />
            }
          </motion.div>
        </div>
      :
        <TransferHistoryBody handleClick={handleClick} />
      }
    </div>
  )
}